// Axios and config
import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";

// Interfaces
import I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse";
import { I_SafetyEvent, I_VehicleIncidentsFilters } from "../interfaces";

// UI utilities
import snackBar from "src/utilities/snackBar/SnackBar";

/**
 * Fetches a paginated, sorted list of vehicle safety events.
 * Falls back to an empty array if the request fails.
 *
 * @param skip - Number of records to skip (for pagination)
 * @param take - Number of records to take (page size)
 * @param sortBy - Field name to sort by
 * @param sortDirection - Sort direction ('asc' or 'desc')
 * @returns A promise that resolves to an array of I_SafetyEvent
 */
const getVehicleSafetyEventsLazy = async (
  skip = 0,
  take = 50,
  sortBy = "ObjectID",
  sortDirection = "asc",
  filters: I_VehicleIncidentsFilters = {}
): Promise<I_SafetyEvent[]> => {
  try {
    const queryParams = new URLSearchParams({
      skip: skip.toString(),
      take: take.toString(),
      sortBy,
      sortDirection,
      ...(filters.stateCode ? { state: filters.stateCode } : {}),
      ...(filters.city ? { city: filters.city } : {}),
      ...(filters.zipCode ? { zipCode: filters.zipCode } : {}),
      ...(filters.locationCode ? { locationCode: filters.locationCode } : {}),
      ...(filters.employeeId
        ? { employeeId: filters.employeeId.toString() }
        : {}),
      ...(filters.labels?.length
        ? { label: filters.labels.join(",") }
        : {}),
    });

    const response = await Axios.get<I_BaseAPIResponse<I_SafetyEvent[]>>(
      `${
        process.env.REACT_APP_API_URL
      }/api/samsara/getVehicleSafetyEvents?${queryParams.toString()}`,
      AxiosConfig.configValue()
    );

    if (response.data.HasError) {
      console.error("API Error:", response.data.ErrorMessage);
      snackBar({
        type: "error",
        text: "Failed to fetch Vehicle Safety Events",
        timeout: 5000,
      });
      return [];
    }

    return response.data.Data;
  } catch (error) {
    console.error("Network or parsing error:", error);
    snackBar({
      type: "error",
      text: "Failed to fetch Vehicle Safety Events",
      timeout: 5000,
    });
    return [];
  }
};

export default getVehicleSafetyEventsLazy;
